import api from "api";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { supportApiBase } from "./useHCPs";

export interface UpdateHcpInput {
  hcpId: number;
  name?: string;
  phone_number?: string;
  email?: string;
  admits_patients?: boolean;
  address?: string;
  slug?: string;
  health_care_organization_id?: number | null;
}

export const useUpdateHcp = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ hcpId, ...data }: UpdateHcpInput) => {
      await api.call(`/health_care_providers/${hcpId}`, {
        method: "PUT",
        data,
        root: supportApiBase,
      });
    },
    {
      onSuccess: (_, { hcpId }) => {
        queryClient.invalidateQueries(queryKeys.hcp(hcpId));
        queryClient.invalidateQueries(queryKeys.hcps());
      },
    }
  );
};
